module.exports = __webpack_public_path__ + "img/en.7bb20816.webp";